import React from "react";
import {
  TodaysClinicalTargets as PkgTodaysClinicalTargets,
  type TodaysClinicalTargetsProps,
} from "@answersnow/pkg-clinical-program";
import SectionWrapper from "../../Widgets/SectionWrapper";

const TodaysClinicalTargets: React.FC<TodaysClinicalTargetsProps> = (props) => (
  <SectionWrapper hideButtons>
    <PkgTodaysClinicalTargets {...props} />
  </SectionWrapper>
);

export default TodaysClinicalTargets;
export type { TodaysClinicalTargetsProps };
